export const typeValues = ['info', 'warn', 'error'];